module.exports = __webpack_public_path__ + "static/League_Gothic-webfont-16ba5d98ae818a0501b8234be97b1610.svg";